module.exports = __webpack_public_path__ + "img/4_49.d12b86fd.png";